/* eslint-disable dot-notation */
import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import {
  Select,
} from 'antd';
import ReportActions from '@Actions/reportActions';
import Helpers from '@Apis/helpers';
import H3DateSelector from '@Uilib/h3DateSelector';
import SelectDepartment from '@Components/Common/SelectDepartment';
import TenantSelector from '../../Common/Selector/TenantSelector';
import './style.scss';
import DownloadReports from './DownloadReports';
import CategoryFilter from '@Components/Common/CategoryFilter';
import CategoryFilterNew from '../../Common/CategoryFilterNew';

const reportName = {
  inventory_report: 'Stock Register',
  inventory_summary: 'Stock Summary',
  stock_transfer_report: 'Stock Transfer Register',
  inventory_adjustment: 'Stock Adjustment Register',
  purchase_ledger: 'Purchase Register',
  purchase_by_vendor: 'Purchase By Vendor',
  purchase_by_product: 'Purchase By Products',
  sales_ledger: 'Sales Register',
  sales_by_customer: 'Sales By Customer',
  sales_by_product: 'Sales By Products',
  stock_inward_report: 'Stock Inwards Report',
  stock_outward_report: 'Stock Outwards Report',
};

/**
 *
 */
class ReportHeader extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      CurrentPage: 1,
      selectedTenant: '',
      selectedTenantIds: '',
      selectedEmails: [],
      openPopover: false,
      selectedMethod: 'last_purchase_price',
      selectedCategory: '',
    };
  }

  componentDidMount() {
    const { user } = this.props;
    this.pushParamsToUrl(Helpers.getValueFromUrl('startDate') || dayjs().utc().startOf('month')
      .valueOf(), Helpers.getValueFromUrl('endDate') || dayjs().utc().endOf('month')
        .valueOf(), Helpers.getValueFromUrl('tenant') || user?.tenant_info?.tenant_id, Helpers.getValueFromUrl('interval') || 'this_month',
      Number(Helpers.getValueFromUrl('department_id')) || Helpers.getDepartmentId(user), (Helpers.getValueFromUrl('costing_method') || 'last_purchase_price'), Helpers.getValueFromUrl('category'));
  }

  /**
   *
   * @param {*} value
   */
  handleDataChange(value) {
    this.setState({ selectedInterval: value });
    if (value === 'today') {
      this.updateDate(dayjs().utc().startOf('day').valueOf(), dayjs().utc().endOf('day').valueOf());
    }
    if (value === 'yesterday') {
      this.updateDate(dayjs().utc().subtract(1, 'days').startOf('day')
        .valueOf(), dayjs().utc().subtract(1, 'days').endOf('day')
          .valueOf());
    }
    if (value === 'this_week') {
      this.updateDate(dayjs().utc().startOf('week').valueOf(), dayjs().utc().endOf('week').valueOf());
    }
    if (value === 'last_week') {
      this.updateDate(dayjs().utc().subtract(1, 'weeks').startOf('week')
        .valueOf(), dayjs().utc().subtract(1, 'weeks').endOf('week')
          .valueOf());
    }
    if (value === 'this_month') {
      this.updateDate(dayjs().utc().startOf('month').valueOf(), dayjs().utc().endOf('month').valueOf());
    }
    if (value === 'last_month') {
      this.updateDate(dayjs().utc().subtract(1, 'months').startOf('month')
        .valueOf(), dayjs().utc().subtract(1, 'months').endOf('month')
          .valueOf());
    }
    if (value === 'this_quarter') {
      this.updateDate(dayjs().utc().quarter(dayjs().utc().quarter()).startOf('quarter')
        .valueOf(), dayjs().utc().endOf('quarter').valueOf());
    }
    if (value === 'last_quarter') {
      this.updateDate(dayjs().utc().quarter(dayjs().utc().quarter()).subtract(1, 'quarter')
        .startOf('quarter')
        .valueOf(), dayjs().utc().quarter(dayjs().utc().quarter()).subtract(1, 'quarter')
          .endOf('quarter')
          .valueOf());
    }
    if (value === 'this_year') {
      this.updateDate(dayjs().utc().startOf('years').valueOf(), dayjs().utc().endOf('years').valueOf());
    }
    if (value === 'last_year') {
      this.updateDate(dayjs().utc().subtract(1, 'years').startOf('years')
        .valueOf(), dayjs().utc().subtract(1, 'years').endOf('years')
          .valueOf());
    }
    if (value === 'customize') {
      this.setState({
        startDateMomentEpoch: null,
        endDateMomentEpoch: null,
      });
    }
  }

  /**
   *
   * @param props
   * @param state
   * @return {{isUserReady}|*|(*&{isUserReady: boolean})}
   */
  static getDerivedStateFromProps(props, state) {
    if (props.user && !state.isUserReady) {
      const { user } = props;
      if (Helpers.getValueFromUrl('startDate') && Helpers.getValueFromUrl('endDate')
        && Helpers.getValueFromUrl('tenant') && Helpers.getValueFromUrl('interval') && Helpers.getValueFromUrl('department_id')) {
        return {
          ...state,
          isUserReady: true,
          startDateMomentEpoch: Number(Helpers.getValueFromUrl('startDate') || dayjs().utc().startOf('month').valueOf()),
          endDateMomentEpoch: Number(Helpers.getValueFromUrl('endDate') || dayjs().utc().endOf('month').valueOf()),
          selectedInterval: Helpers.getValueFromUrl('interval') || 'this_month',
          selectedTenantIds: (Helpers.getValueFromUrl('tenant')?.split(',')?.length > 1 ? Helpers.getValueFromUrl('tenant')?.split(',')?.map(Number) : Number(Helpers.getValueFromUrl('tenant'))) || user?.tenant_info?.tenant_id,
          selectedTenant: Helpers.getValueFromUrl('tenant') || user?.tenant_info?.tenant_id,
          selectedDepartment: Helpers.getValueFromUrl('department_id')?.split(',')?.map(Number),
          selectedEmails: [user.username],
          selectedMethod: Helpers.getValueFromUrl('costing_method') || 'last_purchase_price',
          selectedCategory: Helpers.getValueFromUrl('category')?.split(',')?.filter(Boolean)?.map(Number) || [],
        };
      }
    }
    return state;
  }

  /**
   * @param {*} startDateMomentEpoch
   * @param startDate
   * @param endDate
   * @param {*} endDateMomentEpoch
   */
  updateDate(startDate, endDate) {
    this.setState({
      startDateMomentEpoch: startDate,
      endDateMomentEpoch: endDate,
    });
  }

  /**
   *
   * @param {*} keyword
   * @param {*} status
   * @param {*} stockType
   * @param {*} productCategory
   * @param {*} page
   * @param {*} limit
   */
  pushParamsToUrl(startDateMomentEpoch, endDateMomentEpoch, selectedTenant, interval, selectedDepartment, method, category) {
    const { history } = this.props;
    let url = '';
    if (startDateMomentEpoch) url += `?startDate=${startDateMomentEpoch}`;
    if (endDateMomentEpoch) url += `&endDate=${endDateMomentEpoch}`;
    if (selectedTenant) url += `&tenant=${selectedTenant}`;
    if (interval) url += `&interval=${interval}`;
    if (selectedDepartment) url += `&department_id=${selectedDepartment}`;
    if (method) url += `&costing_method=${method}`;
    if (category) url += `&category=${category}`;

    history.push(url);
  }

  /**
   *
   * @param {*} startDateMomentEpoch
   * @param {*} endDateMomentEpoch
   */
  loadReportsDownloadData(operationType, required) {
    const {
      firstSubUrl, secondSubUrl, user, type, getDownloadReports, getDownloadReportsLoading,
    } = this.props;
    const {
      startDateMomentEpoch, endDateMomentEpoch, selectedTenant, CurrentPage, selectedDepartment, openPopover,
      selectedEmails, selectedMethod, selectedCategory,
    } = this.state;
    let limit = 100;
    if (type === 'stock_inward_report' || type === 'stock_outward_report') {
      limit = 10;
    }

    // firstSubUrl, secondSubUrl, orgId, tenantIds, fromDate, toDate, fileReportType, reportName, sellerId, departmentId, moType, status, emails
    if (!getDownloadReportsLoading) {
      getDownloadReports(firstSubUrl, secondSubUrl, user?.tenant_info?.org_id, selectedTenant || user?.tenant_info?.tenant_id, startDateMomentEpoch, endDateMomentEpoch, operationType, type, '', selectedDepartment, '', '', selectedEmails.join(','), required, '', '', '', '', selectedMethod, '', selectedCategory);
      this.setState({ openPopover: !openPopover });
    }
  }

  isDownloadOptionAvailable() {
    const {
      purchaseByVendor, inventorySummary, type, inventoryAdjustment, stockInward, stockOutward, purchaseByProduct, purchaseLedger, stockTransfer, user,
      inventoryReport, salesLedger, salesByCustomer, salesByProduct, getReportsLoading, getDownloadReportsLoading,
    } = this.props;
    if (type === 'purchase_by_vendor' && purchaseByVendor?.tenant_purchase?.length > 0) return true;
    if (type === 'purchase_by_product' && purchaseByProduct?.tenant_purchase?.length > 0) return true;
    if (type === 'purchase_ledger' && purchaseLedger?.purchase_ledger?.length > 0) return true;
    if (type === 'inventory_adjustment' && inventoryAdjustment?.inventory_adjustment?.length > 0) return true;
    if (type === 'inventory_summary' && inventorySummary?.inventory?.length > 0) return true;
    if (type === 'stock_transfer_report' && stockTransfer?.data?.length > 0) return true;
    if (type === 'inventory_report' && inventoryReport?.data?.length > 0) return true;
    if (type === 'stock_inward_report' && stockInward?.stock_inward?.length > 0) return true;
    if (type === 'stock_outward_report' && stockOutward?.stock_outward?.length > 0) return true;
    if (type === 'sales_ledger' && salesLedger?.data?.length > 0) return true;
    if (type === 'sales_by_customer' && salesByCustomer?.data?.length > 0) return true;
    if (type === 'sales_by_product' && salesByProduct?.data?.length > 0) return true;
    return false;
  }

  /**
   *
   * @param {object} props
   */
  render() {
    const {
      setPage, type, user, getReportsLoading, getDownloadReportsLoading,
    } = this.props;
    const {
      startDateMomentEpoch, endDateMomentEpoch, selectedInterval, selectedTenantIds,
      selectedTenant, selectedDepartment, selectedEmails, openPopover, selectedMethod, selectedCategory,
    } = this.state;
    return (
      <Fragment>
        <div className="page-header__right report-header__wrapper" style={{ width: '100%', padding: '0px', paddingBottom: '1rem' }}>
          <div className="report-header__heading">
            {reportName[`${type}`]}
          </div>
          <div className="report-header__action-container">
            {this.isDownloadOptionAvailable() && (
              <DownloadReports
                getDownloadReportsLoading={getDownloadReportsLoading}
                loadReportsDownloadData={(operationType, required) => this.loadReportsDownloadData(operationType, required)}
                selectedEmails={selectedEmails}
                selectedEmailsChange={(event) => this.setState({ selectedEmails: event })}
                user={user}
                openPopover={openPopover}
                openPopoverChange={() => this.setState({ openPopover: !openPopover })}
              />
            )}
            {!(type === 'inventory_summary' || type === 'inventory_report') && (
              <div className="report-header__date-picker">
                <H3DateSelector
                  selectedInterval={selectedInterval}
                  onListChange={(value) => this.handleDataChange(value)}
                  startDate={startDateMomentEpoch}
                  endDate={endDateMomentEpoch}
                  onDateChange={(date) => {
                    setPage(1);
                    this.setState({
                      startDateMomentEpoch: dayjs(date[0])?.valueOf(),
                      endDateMomentEpoch: dayjs(date[1])?.endOf('day')?.valueOf(),
                      selectedInterval: 'customize',
                    });
                    this.pushParamsToUrl(dayjs(date[0])?.valueOf(), dayjs(date[1])?.endOf('day')?.valueOf(), type =='inventory_report' ? user.tenant_info?.tenant_id :selectedTenant, selectedInterval, selectedDepartment, selectedMethod, selectedCategory);
                  }}
                  disabled={getReportsLoading || getDownloadReportsLoading}
                />
              </div>
            )}
            {
              (type !== 'sales_by_customer' && type !== 'purchase_by_vendor') && type !== 'inventory_report' && (
                <div className="report-header__category">
                  <CategoryFilterNew
                    onChange={(value) => {
                      this.setState({ selectedCategory: value });
                      this.pushParamsToUrl(startDateMomentEpoch, endDateMomentEpoch, type =='inventory_report' ? user.tenant_info?.tenant_id :selectedTenant, selectedInterval, selectedDepartment, selectedMethod, value);
                    }}
                    selectedCategory={selectedCategory}
                    hideTitle
                    style={{
                      borderRadius: '4px',
                      width: '150px',
                    }}
                    placeholder="Select category.."
                  />
                </div>
              )
            }
            <React.Fragment>
              <div className="report-header__tenant-selector">
                <TenantSelector
                  selectedTenant={selectedTenantIds}
                  showSearch
                  showAll={['stock_transfer_report', 'inventory_report', 'purchase_ledger', 'purchase_by_product', 'purchase_by_vendor'].includes(type)}
                  noDropdownAlign
                  onChange={(value) => {
                    setPage(1);
                    if (value === 'All') {
                      this.setState({ CurrentPage: 1, selectedTenantIds: value, selectedTenant: Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.INVENTORY_INDENT, Helpers.permissionTypes.READ).join(',') });
                      type !== 'inventory_report'?  this.pushParamsToUrl(startDateMomentEpoch, endDateMomentEpoch, Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.INVENTORY_INDENT, Helpers.permissionTypes.READ).join(','), selectedInterval, selectedDepartment, selectedMethod, selectedCategory):"";
                    } else {
                      this.setState({ CurrentPage: 1, selectedTenant: value, selectedTenantIds: value });
                      type !== 'inventory_report' ? this.pushParamsToUrl(startDateMomentEpoch, endDateMomentEpoch, value, selectedInterval, selectedDepartment, selectedMethod, selectedCategory) :"";
                    }
                  }}
                  placeholder="Select Business Unit"
                  inputClassName="orgInputContainer"
                  isMultiple={type === 'inventory_report' || type === 'stock_inward_report' || type === 'stock_outward_report'}
                  customStyle={{
                    borderRadius: '4px',
                    width: '200px',
                    fontSize: '13px',
                    marginRight: '10px',
                    paddingTop: '3px',
                    marginBottom: '0px',
                  }}
                  hideTitle
                  includedTenants={Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.INVENTORY_INDENT, Helpers.permissionTypes.READ)}
                />
              </div>
            </React.Fragment>
            {(!['purchase_ledger', 'purchase_by_product', 'purchase_by_vendor', 'inventory_report'].includes(type))
              && (
                <div className="report-header__dept-selector">
                  <SelectDepartment
                    title="Select Department"
                    hideTitle
                    selectedDepartment={selectedDepartment}
                    noDropdownAlign
                    onChange={(value) => {
                      setPage(1);
                      this.setState({
                        selectedDepartment: value?.department_id || value,
                        CurrentPage: 1,
                      });
                      this.pushParamsToUrl(startDateMomentEpoch, endDateMomentEpoch, type =='inventory_report' ? user.tenant_info?.tenant_id :selectedTenant, selectedInterval, value?.department_id || value, selectedMethod, selectedCategory);
                    }}
                    isMultiple={type === 'inventory_report' || type === 'stock_inward_report' || type === 'stock_outward_report'}
                    customStyle={{
                      borderRadius: '4px',
                      width: '150px',
                      fontSize: '13px',
                      marginRight: '10px',
                      padding: '2px ',
                    }}
                    showSearch
                    disabled={getReportsLoading || getDownloadReportsLoading || (user?.tenant_info?.inventory_config?.settings?.department_wise_visibility && Number(user?.tenant_info?.default_store_id) !== Number(Helpers.getTenantDepartmentId(user)))}
                  />
                </div>
              )}

          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ ReportReducers, UserReducers }) => ({
  purchaseByVendor: ReportReducers.purchaseByVendor,
  inventorySummary: ReportReducers.inventorySummary,
  inventoryAdjustment: ReportReducers.inventoryAdjustment,
  purchaseByProduct: ReportReducers.purchaseByProduct,
  purchaseLedger: ReportReducers.purchaseLedger,
  getReportsLoading: ReportReducers.getReportsLoading,
  stockTransfer: ReportReducers.stockTransfer,
  getDownloadReportsLoading: ReportReducers.getDownloadReportsLoading,
  inventoryReport: ReportReducers.inventoryReport,
  salesLedger: ReportReducers.salesLedger,
  salesByCustomer: ReportReducers.salesByCustomer,
  salesByProduct: ReportReducers.salesByProduct,
  stockInward: ReportReducers.stockInward,
  stockOutward: ReportReducers.stockOutward,
  user: UserReducers.user,
});

const mapDispatchToProps = (dispatch) => ({
  getDownloadReports: (firstSubUrl, secondSubUrl, orgId, tenantIds, fromDate, toDate, fileReportType, reportName, sellerId, departmentId, moType, status, emails, noWait, intervals, noOfColumns, selectedMethod, selectedDate, costingMethod, customerId, category) => dispatch(
    ReportActions.getDownloadReports(firstSubUrl, secondSubUrl, orgId, tenantIds, fromDate, toDate, fileReportType, reportName, sellerId, departmentId, moType, status, emails, noWait, intervals, noOfColumns, selectedMethod, selectedDate, costingMethod, customerId, category),
  ),
  getReports: (firstSubUrl, secondSubUrl, orgId, tenantIds, fromDate, toDate, reportType, page, limit, departmentId, sellerId, costingMethod, customerId, category) => dispatch(ReportActions.getReports(firstSubUrl, secondSubUrl, orgId, tenantIds, fromDate, toDate, reportType, page, limit, departmentId, sellerId, costingMethod, customerId, category)),

});
ReportHeader.propTypes = {
  getDownloadReports: PropTypes.func,
  getReports: PropTypes.func,
  type: PropTypes.string,
  user: PropTypes.object,
  inventoryAdjustment: PropTypes.any,
  firstSubUrl: PropTypes.any,
  secondSubUrl: PropTypes.any,
  purchaseByProduct: PropTypes.any,
  purchaseByVendor: PropTypes.any,
  inventorySummary: PropTypes.any,
  purchaseLedger: PropTypes.any,
  stockTransfer: PropTypes.any,
  inventoryReport: PropTypes.any,
  stockInward: PropTypes.any,
  stockOutward: PropTypes.any,
  history: PropTypes.any,
  getReportsLoading: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ReportHeader));
